export const PAGE_PER = 3;

export const MIN_PAGE = 1;

export const FILTER_SEARCH_TYPES = {
  ID: "ID",
  PHONE: "PHONE",
  NONE: "NONE",
} as const;
